import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

import { makeStyles } from "@material-ui/core/styles";

import Input from "@material-ui/core/Input";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { userHasRole } from "../../auth/UserFunctions";

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px",
    marginRight: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const ClassificationData = ({
  type,
  onChange,
  disabled,
  value,
  error,
  children,
  title,
  classification_data,
  operation_types,
  invoice_types,
  client_state_types,
  client_trade_types,
  client_origin_types,
  ...props
}) => {
  const handleChange = event => {
    onChange(event, "classification_data");
  };

  const classes = useStyles();
  const clientStateDisabled =
    disabled ||
    (!userHasRole("admin-client-blocker") &&
      parseInt(classification_data.client_state_type_id) == 7);
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>
          Tipo de operación
        </Typography>
        <Select
          native
          name="operation_type_id"
          inputProps={{
            name: "operation_type_id",
            className: "operation_type_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && classification_data.operation_type_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={classification_data.operation_type_id}
          input={<Input id="grouped-native-select" name="operation_type_id" />}
        >
          <option value="" label="Seleccione" />
          {operation_types.map(operation_type => (
            <option id={operation_type.id} value={operation_type.id}>
              {operation_type.name}
            </option>
          ))}
        </Select>
        {error !== "" && classification_data.operation_type_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Tipo de factura</Typography>
        <Select
          native
          name="invoice_type_id"
          inputProps={{
            name: "invoice_type_id",
            className: "invoice_type_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && classification_data.invoice_type_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={classification_data.invoice_type_id}
          input={<Input id="grouped-native-select" name="invoice_type_id" />}
        >
          <option value="" label="Seleccione" />
          {invoice_types.map(invoice_type => (
            <option id={invoice_type.id} value={invoice_type.id}>
              {invoice_type.name}
            </option>
          ))}
        </Select>
        {error !== "" && classification_data.invoice_type_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>
          Estado del cliente
        </Typography>
        <Select
          native
          name="client_state_type_id"
          inputProps={{
            name: "client_state_type_id",
            className: "client_state_type_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={clientStateDisabled}
          onChange={handleChange}
          required
          error={
            error !== "" && classification_data.client_state_type_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={classification_data.client_state_type_id}
          input={
            <Input id="grouped-native-select" name="client_state_type_id" />
          }
        >
          <option value="" label="Seleccione" />
          {client_state_types.map(client_state_type => (
            <option id={client_state_type.id} value={client_state_type.id}>
              {client_state_type.name}
            </option>
          ))}
        </Select>
        {error !== "" && classification_data.client_state_type_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>
          Rubro del cliente
        </Typography>
        <Select
          native
          name="client_trade_type_id"
          inputProps={{
            name: "client_trade_type_id",
            className: "client_trade_type_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && classification_data.client_trade_type_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={classification_data.client_trade_type_id}
          input={
            <Input id="grouped-native-select" name="client_trade_type_id" />
          }
        >
          <option value="" label="Seleccione" />
          {client_trade_types.map(client_trade_type => (
            <option id={client_trade_type.id} value={client_trade_type.id}>
              {client_trade_type.name}
            </option>
          ))}
        </Select>
        {error !== "" && classification_data.client_trade_type_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        required
        className={classes.formControl}
        inputProps={{ shrink: true }}
      >
        <Typography className={classes.typography}>Origen</Typography>
        <Select
          native
          name="client_origin_type_id"
          inputProps={{
            name: "client_origin_type_id",
            className: "client_origin_type_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && classification_data.client_origin_type_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={classification_data.client_origin_type_id}
          input={
            <Input id="grouped-native-select" name="client_origin_type_id" />
          }
        >
          <option value="" label="Seleccione" />
          {client_origin_types.map(client_origin_type => (
            <option id={client_origin_type.id} value={client_origin_type.id}>
              {client_origin_type.name}
            </option>
          ))}
        </Select>
        {error !== "" && classification_data.client_origin_type_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>
    </React.Fragment>
  );
};

ClassificationData.defaultProps = {
  type: "text",
  className: "",
  isProvider: true,
  provider_types: [],
  disabled: false
};

ClassificationData.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired
};

export default ClassificationData;
